// @flow
import {
  GetMonitoringHistory,
  GetMonitoringHistorySuccess,
  GetMonitoringHistoryError,
  GetCurrentMonitoringStage,
  GetCurrentMonitoringStageSuccess,
  GetCurrentMonitoringStageError,
} from "@modules/profile/constants/actions";
import type { MyAbsenceStageState } from "./types";
import { cloneObject } from "@utils/object";

export const initialState: MyAbsenceStageState = {
  requestsInProgress: 0,
  error: null,
  current: null,
  monitoringHistory: [],
};

export const setLoading = (state: MyAbsenceStageState) => () => {
  return {
    ...state,
    requestsInProgress: ++state.requestsInProgress,
  };
};

export const onGetMonitoringHistorySuccess = (state: MyAbsenceStageState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: null,
    monitoringHistory: payload,
  };
};

export const onGetMonitoringHistoryError = (state: MyAbsenceStageState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
  };
};

export const onGetCurrentMonitoringStageSuccess = (state: MyAbsenceStageState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: null,
    current: payload,
  };
};

export const onGetCurrentMonitoringStageError = (state: MyAbsenceStageState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
  };
};

export default (state: MyAbsenceStageState = initialState, action: Object): MyAbsenceStageState => {
  const act = {
    [GetMonitoringHistory]: setLoading,
    [GetMonitoringHistorySuccess]: onGetMonitoringHistorySuccess,
    [GetMonitoringHistoryError]: onGetMonitoringHistoryError,
    [GetCurrentMonitoringStage]: setLoading,
    [GetCurrentMonitoringStageSuccess]: onGetCurrentMonitoringStageSuccess,
    [GetCurrentMonitoringStageError]: onGetCurrentMonitoringStageError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
